import React from 'react'

import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

// component
import InputField from '../../InputField/InputField.component'

export default function ReceivingEquipmentInput({ title, subTitle, prefix, handleChange, handleRemove, qtyReceived, errors }) {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                <Grid container>
                    <Grid item xs={8}>
                        <Typography variant="h6">{title}</Typography>
                        <Typography variant="h6">{subTitle}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <InputField 
                            id={`${prefix}.quantityReceived`}
                            type="text"
                            placeholder='Qty Received'
                            onChange={handleChange}
                            value={qtyReceived}
                            isValid={errors['quantityReceived']}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}